import { useEffect } from "react";
import {
  getDevEnvironmentColour,
  getDevEnvironmentLabel,
} from "./devEnvironment";
import { setFaviconWithBaseIcon } from "./generateTenantFavicon";

function useEnvironmentAppearance() {
  const label = getDevEnvironmentLabel();
  const colour = label ? getDevEnvironmentColour(label) : null;

  return { label, colour };
}

export function DevEnvironmentFavicon() {
  const { label, colour } = useEnvironmentAppearance();

  useEffect(() => {
    if (!label || !colour) return;

    setFaviconWithBaseIcon("", {
      iconUrl: "/assets/img/logo_plain.png",
      badgeText: label,
      badgeColor: colour,
    });
  }, [colour, label]);

  return null;
}

export function DevEnvironmentIndicator() {
  const { label, colour } = useEnvironmentAppearance();

  if (!label || !colour) return null;

  return (
    <div
      aria-label={`Development environment ${label}`}
      title={`Development environment ${label}`}
      className="h-[20px] shrink-0 flex items-center rounded px-2 border border-white/75 text-white text-xs font-bold tracking-wide shadow"
      style={{
        backgroundColor: colour,
      }}
    >
      DEV {label}
    </div>
  );
}
